import { EnumTipoDomandaModuloDTOTipoAssociazione } from '@framework/api-client';
import {
  ITriggerableDifferences,
  ITriggerableModuleChange,
} from '@framework/common-web';
import { t } from '@framework/i18n';
import React, { useMemo } from 'react';

export interface ISubmissionConfirmUpdateModalContentProps {
  differences: ITriggerableDifferences[];
}

function getAddedLabel(length: number) {
  if (length === 1) {
    return t(
      'module-form.un-modulo-da-compilare-in-aggiunta',
      `Verrà aggiunto il seguente modulo da compilare:`,
    );
  }
  return t(
    'module-form.moduli-da-compilare-in-aggiunta',
    `Saranno aggiunti {{length}} nuovi moduli da compilare:`,
    { length },
  );
}

function getRemovedLabel(length: number) {
  if (length === 1) {
    return t(
      'module-form.rimozione-del-modulo-corrente',
      `Sarà rimosso il seguente modulo:`,
    );
  }
  return t(
    'module-form.rimozione-moduli',
    `Saranno rimossi {{length}} moduli:`,
    { length },
  );
}

export function SubmissionConfirmUpdateModalContent(
  props: ISubmissionConfirmUpdateModalContentProps,
) {
  const { differences } = props;

  const { added, removed } = useMemo(() => {
    const triggerableDifferences = differences[0];

    if (!triggerableDifferences) {
      console.warn("[TriggerableModulesModalContent] Nessuna differenza trovata", { differences }); // prettier-ignore
      return {
        added: [] as ITriggerableModuleChange[],
        removed: [] as ITriggerableModuleChange[],
        inquiries: [],
      };
    }

    const added = triggerableDifferences.moduli.filter(
      m =>
        m.stato === 'AGGIUNTO' &&
        m.tipo === EnumTipoDomandaModuloDTOTipoAssociazione.DINAMICO,
    );
    const removed = triggerableDifferences.moduli.filter(
      m =>
        m.stato === 'RIMOSSO' &&
        m.tipo === EnumTipoDomandaModuloDTOTipoAssociazione.DINAMICO,
    );

    return { added, removed };
  }, [differences]);

  return (
    <>
      <p>
        {t(
          'module-form.salvando-le-richieste-verranno-apportate-le-modifiche',
          'Salvando la richiesta verranno apportate le seguenti modifiche:',
        )}
      </p>
      {added.length > 0 && (
        <>
          <p>{getAddedLabel(added.length)}</p>
          <ul>
            {added.map((m, i) => (
              <li key={m.idModulo}>{m.titolo}</li>
            ))}
          </ul>
        </>
      )}
      {removed.length > 0 && (
        <>
          <p>{getRemovedLabel(removed.length)}</p>
          <ul>
            {removed.map((m, i) => (
              <li key={m.idModulo}>{m.titolo}</li>
            ))}
          </ul>
          <p>
            {t(
              'module-form.avviso-rimozione-moduli',
              'Attenzione, una volta rimossi, i dati compilati dei moduli andranno perduti. Se riattivati in seguito, sarà necessario ricompilare i moduli.',
            )}
          </p>
        </>
      )}
      <p>
        {t(
          'module-form.confermare-le-modifiche-ai-moduli',
          'Confermare le modifiche ai moduli?',
        )}
      </p>
    </>
  );
}
